import { render, staticRenderFns } from "./EditRecipe.vue?vue&type=template&id=e9355648&"
import script from "./EditRecipe.vue?vue&type=script&lang=js&"
export * from "./EditRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports